import React, { Component } from 'react'
import { Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import AddressBox from './AddressBox';
import { withTranslation } from 'react-i18next';
import SvgTick from '../shared/SvgTick'

class CheckoutPageStepBox extends Component {

    render() {

        const { address,
            icon,
            headerText,
            needsConfirmation,
            confirmed,
            confirm,
            editVisible,
            editClick,
            updateFromToDateTime,
            date,
            time,
            disabledButton,
            confirmWithoutAddress,
            noAddress,
            noAddressButtonText,
            t,
            expressPrice,
            onToggleExpress,
            isExpress,
            stepNumber,
            hasLongProcessingItems,
            allItemsAreLongProcessing,
            earliestDate,
            earliestTime,
            earliestWithExpressDate,
            earliestWithExpressTime
        } = this.props;

        if (!address) {
            return null
        }

        let bodyContent;
        if (!confirmed && !noAddress) {
            bodyContent = (
                <div className="info">
                    <img src={require('../../img/baseline-face-24px.svg')} alt="" />
                    <span>
                        1
                        {t('cart.checkout.address.info')}
                    </span>
                </div>
            )
        }

        if (confirmed && noAddress) {
            bodyContent = (
                <div className="info">
                    <span>
                        <strong>{noAddressButtonText}</strong>
                        <div className="mt-3" style={{ fontSize: "16px" }}>
                            {t('footer.hours.weekdays')}<br/> 
                            {t('footer.hours.weekdayHours')}
                        </div>
                        <div className="mt-3" style={{ fontSize: "16px" }}>
                            Hohlstrasse 192,
                            8004 Zürich
                        </div>

                       

                    </span>
                </div>
            )
        }
        
        return (
            <Card className={`checkout-step-box ${needsConfirmation ? 'needsConformation' : confirmed ? 'confirmed' : ''}`}>
                {
                    needsConfirmation &&
                    <>
                        <span className="checkout-step-box-number">
                            <img alt="" src={require('../../img/how-it-works/24.png')} />
                        </span>
                        <span className="checkout-step-box-title">{stepNumber}. {headerText}</span>
                    </>
                }
                <CardHeader>
                    <div class="d-flex align-items-center">
                        <img alt="" src={icon} />
                        <div className={`${expressPrice > 0 ? 'ml-1' : ''}`}>
                            {headerText}
                        </div>
                        { confirmed &&
                            <div className="tick-icon"><SvgTick /></div>
                        }
                    </div>
                    </CardHeader>
                <CardBody>

                    {
                        needsConfirmation || noAddress ?
                            <div style={{ display: "flex", height: "100%" }}>{bodyContent}</div> : <AddressBox {...address} date={date} time={time} editVisible={editVisible} editClick={editClick} updateFromToDateTime={updateFromToDateTime} hasLongProcessingItems={hasLongProcessingItems} allItemsAreLongProcessing={allItemsAreLongProcessing} isExpress={isExpress} earliestDate={earliestDate} earliestTime={earliestTime} earliestWithExpressDate={earliestWithExpressDate} earliestWithExpressTime={earliestWithExpressTime} />
                    }
                </CardBody>
                <CardFooter>
                    <div className="d-flex flex-row flex-wrap justify-content-center" style={{ gap: '15px' }}>
                        {
                            <React.Fragment>
                                {
                                    !confirmed &&
                                    <React.Fragment>
                                        <button className="btn btn-info checkout-btn text-uppercase" onClick={() => confirm(true)} disabled={disabledButton}>
                                            Abholung {t('cart.checkout.address.confirm')}
                                        </button>
                                        <button className="btn btn-info checkout-btn outline text-uppercase" onClick={confirmWithoutAddress} disabled={disabledButton}>
                                            {noAddressButtonText}
                                        </button>
                                    </React.Fragment>
                                }
                                {
                                    confirmed &&
                                    <button className="btn btn-info checkout-btn outline text-uppercase" onClick={() => confirm(false)}>
                                        {t('cart.checkout.address.change')}
                                    </button>
                                }
                            </React.Fragment>
                        }
                    </div>
                </CardFooter>
            </Card>
        );
    }
}

export default withTranslation()(CheckoutPageStepBox);